import React, { useEffect, useState } from "react";
import { api } from "@/lib/api";
import { brl, formatDate } from "@/lib/format";
import { MessageCircle, Search } from "lucide-react";

export default function Customers() {
  const [list, setList] = useState([]);
  const [q, setQ] = useState("");
  useEffect(() => { api.get("/admin/customers").then((r)=>setList(r.data)); }, []);

  const filtered = list.filter((u) => !q || u.name.toLowerCase().includes(q.toLowerCase()) || u.email.includes(q.toLowerCase()));

  return (
    <div className="space-y-5" data-testid="admin-customers">
      <h1 className="font-serif text-3xl text-[#4A3B40]">Clientes</h1>
      <div className="bg-white rounded-2xl border border-[#F9E1E8] p-4">
        <div className="flex items-center gap-2 bg-[#FFF9FA] rounded-full border border-[#F9E1E8] px-4 py-2 mb-4 max-w-md">
          <Search className="w-4 h-4 text-[#8C7A80]" />
          <input value={q} onChange={(e)=>setQ(e.target.value)} placeholder="Buscar cliente..." className="bg-transparent outline-none text-sm flex-1" />
        </div>
        <div className="overflow-x-auto">
          <table className="w-full text-sm">
            <thead>
              <tr className="text-left text-xs text-[#8C7A80] uppercase border-b border-[#F9E1E8]">
                <th className="pb-2">Cliente</th><th className="pb-2">Contato</th><th className="pb-2">Cadastro</th><th className="pb-2">Pedidos</th><th className="pb-2 text-right">Gasto total</th>
              </tr>
            </thead>
            <tbody>
              {filtered.map((u) => (
                <tr key={u.id} className="border-b border-[#F9E1E8] last:border-0" data-testid={`customer-row-${u.email}`}>
                  <td className="py-3">
                    <p className="font-medium text-[#4A3B40]">{u.name}</p>
                    <p className="text-xs text-[#8C7A80]">{u.email}</p>
                  </td>
                  <td>
                    {u.phone && <a href={`https://wa.me/55${u.phone.replace(/\D/g,"")}`} target="_blank" rel="noreferrer" className="text-[#7DBE9E] hover:underline inline-flex items-center gap-1 text-xs"><MessageCircle className="w-3 h-3" /> {u.phone}</a>}
                  </td>
                  <td className="text-[#8C7A80]">{formatDate(u.created_at)}</td>
                  <td>{u.orders_count}</td>
                  <td className="text-right font-semibold text-[#C9708B]">{brl(u.total_spent)}</td>
                </tr>
              ))}
            </tbody>
          </table>
          {filtered.length === 0 && <p className="text-center text-[#8C7A80] py-6">Nenhum cliente encontrado.</p>}
        </div>
      </div>
    </div>
  );
}
